import {
    avy_api_pkg_admin_domain_ResourceAccessType,
    community_CommentOnPost,
} from "src/api"
import {
    IPostAndCommentsItem,
    IPostAndCommentsItemType,
} from "src/types/community-posts-and-comments/communityPostsAndComments"
import { ICommunityPostWithAdminDetailsV2 } from "src/types/community-posts-and-comments/communityPostWithAdminDetailsV2"
import { GridRowsProp } from "src/types/data-grid-pro"

export type GridRowsPropExtended = IPostAndCommentsItem & (GridRowsProp | {})

export interface IPostInitialStateFilterItem {
    field: string
    operator: string
    value: string | number | boolean | (string | number | boolean)[]
}

export interface IPostAndCommentsFilter {
    id: string
    label: string
}

export interface IUnifiedItemParams {
    item: ICommunityPostWithAdminDetailsV2 | community_CommentOnPost
    id: string
    parentHierarchy: string[]
    itemType: IPostAndCommentsItemType
    accessType?: avy_api_pkg_admin_domain_ResourceAccessType
    communityName?: string
    parentId?: number
    communityId?: number
}

export interface IRouteParams {
    param: string
    value: string
}

export interface IConfirmModalProps {
    onConfirm: (confirmed: boolean) => Promise<void>
    title: string
    content: string
}

export enum CommunityPostStatus {
    SCHEDULED = "scheduled",
    PUBLISHED = "published",
}
